import { push as cPush, replace as cReplace } from 'connected-react-router';
function create(method) {
  return (...args) => {
    const v = args[0];
    if (window.event && window.event.metaKey) {
      window.open(adjustPath(v));
      return null;
    }
    if (typeof v === 'string') {
      return method(adjustPath(v));
    }
    if (v && v.pathname) {
      const p = v.pathname;
      return method({
        ...v,
        pathname: adjustPath(p)
      });
    }
    return method(...args);
  };
}
function adjustPath(path) {
  if (typeof path === 'string' && path[0] === '/') {
    const base = window.Molten.getConfig('baseUrl', null);
    if (base == null || base[0] !== '/' || path.startsWith(base)) {
      return path;
    }
    if (path === '/') {
      return base;
    }
    return base + path;
  }
  if (Array.isArray(path)) {
    return path.map(s => adjustPath(s));
  }
  return path;
}
const push = create(cPush);
const replace = create(cReplace);
export default {
  push,
  replace,
  adjustPath
};
export { adjustPath, push, replace };